// Sample component with a sortable grid and create/edit/delete
class SampleController {
    static $inject = ['apiFactory', 'stToast', '$uibModal', '$http', 'reportService'];

    /**
     * @param {ApiFactory} apiFactory
     * @param {StToast} toast
     * @param {ng.ui.bootstrap.IModalService} $uibModal
     * @param {ng.IHttpService} $http
     * @param {ReportService} reportService
     */
    constructor(apiFactory, toast, $uibModal, $http, reportService) {
        this.samplesApi = apiFactory.create('api/v1/samples');
        this.toast = toast;
        this.$uibModal = $uibModal;
        this.$http = $http;
        this.reportService = reportService;

        this.samples = [];

        this.orderBy = {
            prop: 'sample_name',
            reverse: false,
            icon(prop) {
                if (prop === this.prop) {
                    return this.reverse ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-top';
                }
                return 'glyphicon-none';
            }
        };
    }

    $onInit() {
        // load data for dropdowns, etc...
        return this.samplesApi.all()
            .then(samples => this.samples = samples)
            .catch(this.toast.errorHandler);
    }

    /** @param {string} prop */
    sort = prop => {
        if (prop === this.orderBy.prop) {
            this.orderBy.reverse = !this.orderBy.reverse;
        } else {
            this.orderBy.prop = prop;
            this.orderBy.reverse = false;
        }
    }

    /** @param {Sample} sample */
    deleteSample = sample => {
        return this.samplesApi.delete(sample.sample_id)
            .then(() => {
                this.samples.splice(this.samples.indexOf(sample), 1);
                this.toast.success('Success', 'Sample Deleted');
            })
            .catch(this.toast.errorHandler);
    }

    /** @param {Sample} sample */
    editSample = sample => {
        // make a copy to edit
        const editSample = angular.copy(sample);
        this.$uibModal
            .open({
                component: 'editSampleModal',
                resolve: {
                    sample: () => editSample
                }
            })
            .result
            .then(updatedSample => {
                const existingSample = this.samples.find(c => c.sample_id === updatedSample.sample_id);
                angular.extend(existingSample, updatedSample); // update existing sample object with updated properties
                this.toast.success('Success', 'Sample updated');
            })
            .catch(angular.noop); // suppress 'Possibly unhandled rejection' message in console
    }

    createSample = () => {
        // set default properties
        const editSample = { is_active: 'N' };
        this.$uibModal
            .open({
                component: 'createSampleModal',
                resolve: {
                    sample: () => editSample
                }
            })
            .result
            .then(newSample => {
                this.samples.push(newSample);
                this.toast.success('Success', 'Sample created');
            })
            .catch(angular.noop); // suppress 'Possibly unhandled rejection' message in console
    }

    runGenericReport(sample) {
        this.reportService.createReport('generic_report.rpt', { '@sample_id': sample.sample_id });
    }

    runOtherReport(sample) {
        this.reportService.createBarcodeReport('other_report.rpt', { '@sample_id': sample.sample_id }, [sample.sample_id]);
    }
}

angular
    .module("app")
    .component("sample", {
        templateUrl: "src/app/sample/sample.html",
        controller: SampleController
    });
